import OutlinedFieldFormik from './outlinedFieldFormik'

const EmailFieldFormik = (props: React.ComponentProps<typeof OutlinedFieldFormik>) => {
  return <OutlinedFieldFormik {...props} type='email' placeholder='exemple@nomdedomaine.ca' />
}

export default EmailFieldFormik
